// 牌与牌值。两副牌 108 张；点数 2–14（A=14），小王 16、大王 17。
// 规则主源：游戏 docs/规则配置.md；子系统品类基线 ../../docs/品类设计基线.md。

export type Suit = 'S' | 'H' | 'C' | 'D' | 'J'; // 黑桃 红桃 梅花 方块 王
export interface Card { id: number; suit: Suit; rank: number }

export const SMALL_JOKER = 16;
export const BIG_JOKER = 17;
export const LEVEL_POWER = 15; // 级牌作单张、对子、三张、炸弹时排在 A 之上、小王之下

export function makeDeck(): Card[] {
  const cards: Card[] = [];
  let id = 0;
  for (let deck = 0; deck < 2; deck++) {
    for (const suit of ['S', 'H', 'C', 'D'] as const) {
      for (let rank = 2; rank <= 14; rank++) cards.push({ id: id++, suit, rank });
    }
    cards.push({ id: id++, suit: 'J', rank: SMALL_JOKER }, { id: id++, suit: 'J', rank: BIG_JOKER });
  }
  return cards;
}

/** 逢人配：红桃级牌，可代替除大小王以外的任何牌。 */
export const isWild = (c: Card, level: number): boolean => c.suit === 'H' && c.rank === level;
export const isJoker = (c: Card): boolean => c.suit === 'J';

/** 单张、对子、三张、炸弹里的大小：大王 > 小王 > 级牌 > A > … > 2。顺子类不用它。 */
export const power = (rank: number, level: number): number => (rank === level ? LEVEL_POWER : rank);

/** 理牌顺序：按 power 降序，同点按花色。 */
export function sortHand(cards: Card[], level: number): Card[] {
  const suitOrder: Record<Suit, number> = { J: 0, S: 1, H: 2, C: 3, D: 4 };
  return [...cards].sort((a, b) => power(b.rank, level) - power(a.rank, level) || suitOrder[a.suit] - suitOrder[b.suit] || a.id - b.id);
}

const RANK_NAME: Record<number, string> = { 11: 'J', 12: 'Q', 13: 'K', 14: 'A', 16: '小王', 17: '大王' };
const SUIT_MARK: Record<Suit, string> = { S: '♠', H: '♥', C: '♣', D: '♦', J: '' };
export const rankName = (rank: number): string => RANK_NAME[rank] ?? String(rank);
export const cardName = (c: Card): string => `${SUIT_MARK[c.suit]}${rankName(c.rank)}`;

/** 可复现的随机数（mulberry32），发牌与机器人共用，测试按种子回放。 */
export function rng(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function shuffle<T>(items: T[], rand: () => number): T[] {
  const a = [...items];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
